import { formatJsonDataset as fjd } from "../../components/renderers";

export const budgetconfig = {

  budgetperiod: {
    service: {
      name: 'budgetperiod',
      title: 'Budget Periods',
      num: true,
      fields: [
        'rid','nam','shc','rfn','sdt','edt','dsc','dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['rfn','Reference'],
        ['sdt','Start Date'],
        ['edt','End Date'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Reference', v:'rfn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'rfn', label:'Reference', type:'tf', req:1, ops:{} },
        { id:'sdt', label:'Start Date', type:'df', req:1, ops:{} },
        { id:'edt', label:'End Date', type:'df', req:1, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  budgetplan: {
    service: {
      name: 'budgetplan',
      title: 'Budget Plans',
      num: true,
      fields: ['rid','nam','shc','dsc','ati','atn','atc','bci','bcn','bcc','bpi','bpn','bpc','ver','bti','btn','btc','bsi','bsn','bsc','sci','scn','scc','edi','edn','edc','dcd','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['atn','Cost Center'],
        ['bcn','Cycle'],
        ['bpn','Period'],
        ['ver','Version'],
        ['btn','Type'],
        ['bsn','State'],
        ['scn','Scenario'],
        ['dsc','Description'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Scenario', v:'scn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'ati', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'bci', label:'Cycle', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetcycle' } },
        { id:'bpi', label:'Period', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetperiod' } },
        { id:'ver', label:'Version', type:'nf', req:1, ops:{} },
        { id:'bti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgettype' } },
        { id:'bsi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetstate' } },
        { id:'sci', label:'Scenario', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetscenario' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  lineitem: {
    service: {
      name: 'lineitem',
      title: 'Budget Line Items',
      num: true,
      fields: ['rid','nam','shc','dsc','bpi','bpn','bpc','aci','acn','acc','cui','cun','cuc','amt','bal','lsi','lsn','lsc','pdi','pdn','pdc','loi','lon','loc','lti','ltn','ltc','qty','upr','edi','edn','edc','dcd','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['bpn','Plan'],
        ['acn','Account'],
        ['pdn','Product'],
        ['lon','Location'],
        ['ltn','Location Type'],
        ['qty','Quantity'],
        ['upr','Unit Price'],
        ['amt','Amount'],
        ['bal','Balance'],
        ['lsn','State'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Product', v:'pdn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'bpi', label:'Budget Plan', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetplan' } },
        { id:'aci', label:'Account', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'chartofaccounts' } },
        { id:'cui', label:'Currency', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'currency' } },
        { id:'pdi', label:'Product', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'product' } },
        { id:'loi', label:'Location', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'location' } },
        { id:'lti', label:'Location Type', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'locationtype' } },
        { id:'qty', label:'Quantity', type:'nf', req:0, ops:{} },
        { id:'upr', label:'Unit Price', type:'nf', req:0, ops:{} },
        { id:'amt', label:'Amount', type:'nf', req:1, ops:{} },
        { id:'bal', label:'Balance', type:'nf', req:0, ops:{} },
        { id:'lsi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'lineitemstate' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  revision: {
    service: {
      name: 'revision',
      title: 'Budget Revisions',
      num: true,
      fields: [
        'rid','rfn','lii','lin','lic','omt','nmt','rsn','xdt','edi','edn','edc','dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['rfn','Reference'],
        ['lin','Line Item'],
        ['omt','Old Amount'],
        ['nmt','New Amount'],
        ['rsn','Reason'],
        ['xdt','Revision Date'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Reference', v:'rfn' },
          { t:'Line Item', v:'lin' },
          { t:'Reason', v:'rsn' }
        ],
        def:'rfn'
      },
      eform: [
        { id:'rfn', label:'Reference', type:'tf', req:1, ops:{} },
        { id:'lii', label:'Line Item', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'lineitem' } },
        { id:'omt', label:'Old Amount', type:'nf', req:1, ops:{} },
        { id:'nmt', label:'New Amount', type:'nf', req:1, ops:{} },
        { id:'rsn', label:'Reason', type:'ta', req:0, ops:{} },
        { id:'xdt', label:'Revision Date', type:'df', req:1, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  transaction: {
    service: {
      name: 'transaction',
      title: 'Transactions',
      num: true,
      fields: [
        'rid','rfn','cci','ccn','ccc','aci','acn','acc','cui','cun','cuc','amt','dtl',
        'pyi','pyn','pyc','pye','xdt','xti','xtn','xtc','xsi','xsn','xsc','edi','edn','edc',
        'dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['rfn','Reference'],
        ['ccn','Cost Center'],
        ['acn','Account'],
        ['cun','Currency'],
        ['amt','Amount'],
        ['dtl','Details'],
        ['pyn','Payee'],
        ['xdt','Date'],
        ['xtn','Type'],
        ['xsn','State'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Reference', v:'rfn' },
          { t:'Details', v:'dtl' },
          { t:'Payee', v:'pyn' }
        ],
        def:'rfn'
      },
      eform: [
        { id:'rfn', label:'Reference', type:'tf', req:1, ops:{} },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'aci', label:'Account', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'chartofaccounts' } },
        { id:'cui', label:'Currency', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'currency' } },
        { id:'amt', label:'Amount', type:'nf', req:1, ops:{} },
        { id:'dtl', label:'Details', type:'ta', req:0, ops:{} },
        { id:'pyi', label:'Payee Staff', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'staff' } },
        { id:'pye', label:'Payee Name', type:'tf', req:0, ops:{} },
        { id:'xdt', label:'Transaction Date', type:'df', req:1, ops:{} },
        { id:'xti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'transactiontype' } },
        { id:'xsi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'transactionstate' } },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  budgetexecution: {
    service: {
      name: 'budgetexecution',
      title: 'Budget Execution',
      num: true,
      fields: ['rid','rfn','lii','lin','lic','bpi','bpn','bpc','exd','qty','upr','amt','nti','ntn','ntc','soi','son','soc','xsi','xsn','xsc','edi','edn','edc','dcd','exi','sts','ast','stp'],
      grid: [
        ['rfn','Reference'],
        ['lin','Line Item'],
        ['bpn','Period'],
        ['exd','Execution Date'],
        ['qty','Quantity'],
        ['upr','Unit Price'],
        ['amt','Amount'],
        ['ntn','Nature'],
        ['son','Source'],
        ['xsn','State'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Reference', v:'rfn' },
          { t:'Line Item', v:'lin' },
          { t:'Nature', v:'ntn' }
        ],
        def:'rfn'
      },
      eform: [
        { id:'rfn', label:'Reference', type:'tf', req:0, ops:{} },
        { id:'lii', label:'Line Item', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'lineitem' } },
        { id:'bpi', label:'Period', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetperiod' } },
        { id:'exd', label:'Execution Date', type:'df', req:1, ops:{} },
        { id:'qty', label:'Quantity', type:'nf', req:0, ops:{} },
        { id:'upr', label:'Unit Price', type:'nf', req:0, ops:{} },
        { id:'amt', label:'Amount', type:'nf', req:1, ops:{} },
        { id:'nti', label:'Nature', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'executionnature' } },
        { id:'soi', label:'Source', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'executionsource' } },
        { id:'xsi', label:'State', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'transactionstate' } },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  investmentproject: {
    service: {
      name: 'investmentproject',
      title: 'Investment Projects',
      num: true,
      fields: ['rid','nam','shc','dsc','cci','ccn','ccc','bpi','bpn','bpc','iti','itn','itc','loi','lon','loc','lii','lin','lic','aci','acn','acc','pam','aam','xsi','xsn','xsc','edi','edn','edc','dcd','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['ccn','Cost Center'],
        ['bpn','Period'],
        ['itn','Type'],
        ['lon','Location'],
        ['lin','Line Item'],
        ['acn','Activity'],
        ['pam','Planned Amount'],
        ['aam','Actual Amount'],
        ['xsn','State'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Cost Center', v:'ccn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'bpi', label:'Period', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetperiod' } },
        { id:'iti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'investmenttype' } },
        { id:'loi', label:'Location', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'location' } },
        { id:'lii', label:'Line Item', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'lineitem' } },
        { id:'aci', label:'Activity', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'pam', label:'Planned Amount', type:'nf', req:0, ops:{} },
        { id:'aam', label:'Actual Amount', type:'nf', req:0, ops:{} },
        { id:'xsi', label:'State', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'transactionstate' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

};